import React, { useEffect } from "react";
import { TPanoramaVm } from "../data";

import useCommonDataStore from "../stores/common.store";
// import { ReactPhotoSphereViewer } from "react-photo-sphere-viewer";

const PanoramaPopup = ({
  vm,
  prefix,
  show,
  init,
  clear,
}: {
  vm: TPanoramaVm;
  prefix: string;
  show: boolean;
  init: () => void;
  clear: () => void;
}) => {
  const { commonData } = useCommonDataStore();
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const [data, setData] = React.useState<any>(null);
  const [imgUrl, setImgUrl] = React.useState<string>("");

  useEffect(() => {
    if (!show) {
      setData(null);
      setImgUrl("");
    }
  }, [show]);

  useEffect(() => {
    if (commonData.openIndex === "" || commonData.openIndex === null || !show)
      return;

    const split = commonData.openIndex.split(":");
    if (split.length < 2 || split[0] !== prefix) return;

    const dt = vm.items.find((item) => split[1] === String(`p${item.index}`));

    console.log("PanoramaPopup dt", prefix, dt);

    if (dt) {
      setData(dt);
      setImgUrl(dt.img);
    }
  }, [commonData.openIndex, commonData.isActive, vm.items, prefix, vm, show]);

  const openNewWindow = (url: string) => {
    window.open(`/#/panorama?imgurl=${url}`, "_blank");
  };

  return (
    <div
      className="panorama-popup"
      style={{
        position: "fixed",
        zIndex: 20,
        top: "50px",
        right: 0,
        display: data && show ? "block" : "none",
      }}
    >
      <div className="container popupStyle">
        <div className="content-box">
          <div style={{ width: "100%" }}>
            <button
              className="btnStyle"
              style={{ position: "absolute", left: "12px" }}
              onClick={() => openNewWindow(data.url)}
            >
              파노라마뷰 보기
            </button>
            <button
              // className="btnStyle"
              style={{
                position: "absolute",
                right: "16px",
                border: "none",
                background: "none",
                fontSize: "large",
                fontWeight: "bold",
                padding: "10px 4px",
                cursor: "pointer",
              }}
              onClick={() => {
                setData(null);
                setImgUrl("");
                clear();
                init();
              }}
            >
              X
            </button>
          </div>
          <img src={imgUrl} style={{ width: "100%" }} />

          {/* <ReactPhotoSphereViewer
            height={"40vh"}
            loadingTxt={"Loading..."}
            src={imgUrl}
            width={"100%"}
          ></ReactPhotoSphereViewer> */}
        </div>
      </div>
    </div>
  );
};

export default PanoramaPopup;
